import * as styles from "./YearPickerArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerArrowProps } from "./YearPicker.types";

export function YearPickerArrow({
  className,
  style,
  ...props
}: YearPickerArrowProps): JSX.Element {
  const { size } = useYearPickerContext();

  return (
    <BasePopover.Arrow
      data-slot="year-picker-arrow"
      className={clsx(styles.arrow({ size }), className)}
      style={{ left: "50%", transform: "translateX(-50%)", ...style }}
      {...props}
    />
  );
}
